 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddDevice":"AddDevice","ChatLayout":"ChatLayout","Employees":"Employees","Error404":"Error404","Error429":"Error429","Error500":"Error500","ForgottenPassword":"ForgottenPassword","GlobalLayout":"GlobalLayout","Home":"Home","Impersonation":"Impersonation","Login":"Login","ResetPassword":"ResetPassword","ResetPasswordCodeVerification":"ResetPasswordCodeVerification","TwoFactorAuthentication":"TwoFactorAuthentication","AddIssue":"AddIssue","DetailsIssue~RegisterIssue":"DetailsIssue~RegisterIssue","DetailsIssue":"DetailsIssue","RegisterIssue":"RegisterIssue","Register":"Register","CompaniesDetails":"CompaniesDetails","Reviews":"Reviews","CompaniesIssues":"CompaniesIssues","Issues":"Issues","Profile":"Profile","System":"System","Companies":"Companies"}[chunkId]||chunkId) + "." + {"AddDevice":"f81072c9","ChatLayout":"d0ff97e8","Employees":"d828ed3a","Error404":"41aaa712","Error429":"010d0d24","Error500":"d7ef42a8","ForgottenPassword":"1fa15218","GlobalLayout":"9b7e1705","Home":"60e1d9ba","Impersonation":"88000b0b","Login":"3125eea5","ResetPassword":"81fe8b84","ResetPasswordCodeVerification":"145a055a","TwoFactorAuthentication":"71937985","chunk-09662e11":"81484454","chunk-224da57d":"f291f68f","chunk-2886923e":"c6c507a5","chunk-29a9683c":"c397e801","chunk-2d0d3c79":"4c98d39b","chunk-2d224a96":"d6cacf97","chunk-2d231187":"ea4e063d","chunk-536fbe3c":"ced37540","chunk-b1370b26":"9ff27508","chunk-34280d46":"01eff167","chunk-2d0daed2":"c0dce09d","chunk-594ccdee":"6874af21","AddIssue":"50d1f0fa","DetailsIssue~RegisterIssue":"8e8f7460","DetailsIssue":"2b574d5b","RegisterIssue":"455ab9d8","Register":"ccabe820","chunk-4f7497a0":"0bc033b3","chunk-5679a8c8":"dd178cd5","chunk-71f688c4":"1021a3ee","chunk-650ad7a6":"3ce4ae71","chunk-a79d1690":"02678b21","chunk-79b98ffb":"a8a94d5b","chunk-e177cb90":"b7872f97","CompaniesDetails":"53d90c1b","Reviews":"b17f5368","chunk-1f0caa8b":"361416c5","chunk-337b7293":"b99c461c","chunk-e2b8b494":"2467516c","chunk-61ea07e0":"a4e757e3","chunk-8f31e558":"3ae3f1ca","chunk-5cba216b":"7eeae53c","chunk-786a8384":"1098eed0","chunk-abb49458":"57b33012","CompaniesIssues":"a8c28c87","Issues":"6cf50848","Profile":"94f144d5","System":"b9348d3b","chunk-18082c3f":"c49698ed","Companies":"c44daa6e","chunk-8e8469dc":"98d0c020","chunk-d70ef9fa":"4903a10c","chunk-d6e6c11a":"02e95008","chunk-2d0c84cf":"9de75678","chunk-2d0b8eef":"4dfb9fe0","chunk-2d0bdbe7":"1ce6b24f","chunk-2d2095ed":"229aac45","chunk-2d229b6a":"79b30128","chunk-780a9e22":"b51c10f2","chunk-2d0cba59":"14223376","chunk-74a0fa2f":"b9ade910","chunk-1328b420":"95fa9780","chunk-2d0bd59a":"6ea67493","chunk-2d0c8838":"bfe6380f","chunk-2d0ccc04":"ace6cf57","chunk-2d0d7809":"d3c3a3a7","chunk-2d22b9db":"bbd86cc2","chunk-2d2315e9":"7489a114"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Employees":1,"GlobalLayout":1,"Home":1,"Impersonation":1,"ResetPassword":1,"ResetPasswordCodeVerification":1,"TwoFactorAuthentication":1,"chunk-09662e11":1,"chunk-224da57d":1,"chunk-2886923e":1,"chunk-29a9683c":1,"chunk-536fbe3c":1,"chunk-b1370b26":1,"chunk-594ccdee":1,"AddIssue":1,"DetailsIssue~RegisterIssue":1,"DetailsIssue":1,"RegisterIssue":1,"Register":1,"chunk-4f7497a0":1,"chunk-5679a8c8":1,"chunk-71f688c4":1,"chunk-650ad7a6":1,"chunk-a79d1690":1,"chunk-79b98ffb":1,"chunk-e177cb90":1,"CompaniesDetails":1,"Reviews":1,"chunk-1f0caa8b":1,"chunk-337b7293":1,"chunk-e2b8b494":1,"chunk-61ea07e0":1,"chunk-8f31e558":1,"chunk-5cba216b":1,"chunk-786a8384":1,"chunk-abb49458":1,"CompaniesIssues":1,"Issues":1,"Profile":1,"chunk-18082c3f":1,"Companies":1,"chunk-8e8469dc":1,"chunk-74a0fa2f":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddDevice":"AddDevice","ChatLayout":"ChatLayout","Employees":"Employees","Error404":"Error404","Error429":"Error429","Error500":"Error500","ForgottenPassword":"ForgottenPassword","GlobalLayout":"GlobalLayout","Home":"Home","Impersonation":"Impersonation","Login":"Login","ResetPassword":"ResetPassword","ResetPasswordCodeVerification":"ResetPasswordCodeVerification","TwoFactorAuthentication":"TwoFactorAuthentication","AddIssue":"AddIssue","DetailsIssue~RegisterIssue":"DetailsIssue~RegisterIssue","DetailsIssue":"DetailsIssue","RegisterIssue":"RegisterIssue","Register":"Register","CompaniesDetails":"CompaniesDetails","Reviews":"Reviews","CompaniesIssues":"CompaniesIssues","Issues":"Issues","Profile":"Profile","System":"System","Companies":"Companies"}[chunkId]||chunkId) + "." + {"AddDevice":"31d6cfe0","ChatLayout":"31d6cfe0","Employees":"eec789da","Error404":"31d6cfe0","Error429":"31d6cfe0","Error500":"31d6cfe0","ForgottenPassword":"31d6cfe0","GlobalLayout":"a8623933","Home":"731ed283","Impersonation":"f4fd496c","Login":"31d6cfe0","ResetPassword":"41de0b3d","ResetPasswordCodeVerification":"411cac8c","TwoFactorAuthentication":"411cac8c","chunk-09662e11":"d4bac10a","chunk-224da57d":"531686f2","chunk-2886923e":"be30d337","chunk-29a9683c":"42100da0","chunk-2d0d3c79":"31d6cfe0","chunk-2d224a96":"31d6cfe0","chunk-2d231187":"31d6cfe0","chunk-536fbe3c":"39d88a95","chunk-b1370b26":"9db72e1f","chunk-34280d46":"31d6cfe0","chunk-2d0daed2":"31d6cfe0","chunk-594ccdee":"2090ba31","AddIssue":"49830f27","DetailsIssue~RegisterIssue":"b4163c6e","DetailsIssue":"49830f27","RegisterIssue":"41101002","Register":"6f2c5f19","chunk-4f7497a0":"48a07237","chunk-5679a8c8":"aa8e8b56","chunk-71f688c4":"108982c8","chunk-650ad7a6":"f2c87d22","chunk-a79d1690":"f2c87d22","chunk-79b98ffb":"43b55ea8","chunk-e177cb90":"e4546627","CompaniesDetails":"7c4567fe","Reviews":"d36aefd2","chunk-1f0caa8b":"ac3136ef","chunk-337b7293":"d2b90476","chunk-e2b8b494":"d2b90476","chunk-61ea07e0":"49830f27","chunk-8f31e558":"be3ec15f","chunk-5cba216b":"5448a338","chunk-786a8384":"d4bac10a","chunk-abb49458":"b5fa9383","CompaniesIssues":"f4fd496c","Issues":"f4fd496c","Profile":"a597b95b","System":"31d6cfe0","chunk-18082c3f":"79741636","Companies":"15a10d2a","chunk-8e8469dc":"ac3136ef","chunk-d70ef9fa":"31d6cfe0","chunk-d6e6c11a":"31d6cfe0","chunk-2d0c84cf":"31d6cfe0","chunk-2d0b8eef":"31d6cfe0","chunk-2d0bdbe7":"31d6cfe0","chunk-2d2095ed":"31d6cfe0","chunk-2d229b6a":"31d6cfe0","chunk-780a9e22":"31d6cfe0","chunk-2d0cba59":"31d6cfe0","chunk-74a0fa2f":"cd5ae6a4","chunk-1328b420":"31d6cfe0","chunk-2d0bd59a":"31d6cfe0","chunk-2d0c8838":"31d6cfe0","chunk-2d0ccc04":"31d6cfe0","chunk-2d0d7809":"31d6cfe0","chunk-2d22b9db":"31d6cfe0","chunk-2d2315e9":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
